import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IEmailUsProps } from '../types';
import { EmailUs } from '../EmailUs';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IEmailUsProps = elementAttributesToProps(domNode);

  return Promise.resolve(<EmailUs {...props} />);
};

export default rehydrator;
